import { Component } from '@angular/core';

@Component({
    selector: 'gbc-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    standalone: true
})
export class LoadingSpinnerComponent {
}
